<template>
  <div class="schedule-container">
    <section class="schedule-actions">
      <nav class="level">
        <div class="level-left">
          <div class="level-item">
            <slot></slot>
          </div>
        </div>

        <div class="level-right">
          <div class="level-item datepicker-container">
            <button class="button is-white" @click="previousDay" :disabled="isDisabled">
              <font-awesome-icon icon="chevron-left" />
            </button>
            <Datepicker
              input-class="input"
              :monday-first="true"
              :value="localDate"
              :format="customFormatter"
              :highlighted="highlighted"
              :disabledDates="disabledDays"
              :disabled="isDisabled"
              @opened="onDateOpened"
              @closed="onDateClosed"
              @input="onDateInput"
            />
            <button
              class="button is-white"
              @click="nextDay"
              :disabled="isNextDisabled || isDisabled"
            >
              <font-awesome-icon icon="chevron-right" />
            </button>
          </div>

          <div class="level-item refresh-container">
            <button class="button refresh-button" @click="$emit('refresh')" :disabled = "isDisabled">
              <span class="icon"
                ><font-awesome-icon
                  :icon="isLoading ? 'sync-alt' : 'sync-alt'"
                  :spin="isLoading"
              /></span>
              <span>Refresh</span>
            </button>
          </div>
        </div>
      </nav>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "ScheduleActions",
  props: {
    date: { type: [String, Date], default: null },
    highlighted: { type: Object, default: () => ({}) },
    disabledDays: { type: [Array, Object], default: () => [] },
    customFormatter: { type: Function, required: true },
    isLoading: { type: Boolean, default: false },
    isDisabled: {type: Boolean, default: false},
    onDateOpened: { type: Function, required: true },
    onDateClosed: { type: Function, required: true },
  },

  data() {
    return {
      localDate: this.date,
    };
  },

  watch: {
    date(val) {
      this.localDate = val;
    },
  },

  methods: {
    onDateInput(val) {
      this.localDate = val;
      this.$emit("update:date", val);
    },

    onopen() {
      this.$emit("open-date");
    },
    onClosed() {
      this.$emit("date-closed");
    },

    previousDay() {
      const prevDate = moment(this.localDate).subtract(1, "day").toDate();
      this.localDate = prevDate;
      this.$emit("update:date", this.localDate);
      this.onDateClosed();
    },

    nextDay() {
      const nextDate = moment(this.localDate).add(1, "day").toDate();
      this.localDate = nextDate;
      this.$emit("update:date", this.localDate);
      this.onDateClosed();
    },
  },

  computed: {
    isNextDisabled() {
      if (!this.localDate || !this.disabledDays?.from) return false;

      const nextDate = moment(this.localDate).add(1, "day").startOf("day");
      const fromDate = moment(this.disabledDays.from).startOf("day");

      return nextDate.isSameOrAfter(fromDate);
    },
  },

  components: {
    Datepicker,
  },
};
</script>

<style lang="scss" scoped>
.schedule-container {
  margin-bottom: 16px;

  .datepicker-container {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 0 2px;
    display: flex;
    align-items: center;
    height: 40px;

    ::v-deep(.input),
    .input,
    :deep(.input) {
      border: none;
      text-align: center;
      font-weight: 500;
      width: 150px;
      height: 100%;
    }

    .button {
      border: none;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .refresh-button {
    border: 1px solid #ddd;
    border-radius: 8px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
}

@media screen and (max-width: 800px) {
  .schedule-container {
    margin-bottom: 12px;

    .schedule-actions {
      .level {
        flex-direction: column;
        align-items: stretch;
        margin-bottom: 0;

        .level-left {
          margin-bottom: 12px;

          .level-item {
            width: 100%;
            
            ::v-deep(.control),
            :deep(.control) {
              width: 100%;
              margin-bottom: 0;

              .input {
                width: 100%;
              }
            }
          }
        }

        .level-right {
          display: flex;
          flex-direction: row;
          align-items: stretch;
          justify-content: space-between;
          gap: 12px;
          margin: 0;

          .level-item {
            display: flex;
            align-items: stretch;
            margin-bottom: 0;
            
            &.datepicker-container {
              flex: 1;
            }

            &.refresh-container {
              flex: 0 0 auto;
              
              .refresh-button {
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .schedule-container {
    .level-right{
      margin: 0;
    }
    .datepicker-container {
      height: 38px;


      ::v-deep(.input),
      .input,
      :deep(.input) {
        width: 120px;
        font-size: 14px;
      }
    }

    .refresh-button {
      height: 38px;
      font-size: 14px;
    }
  }
}


@media screen and (max-width: 480px) {
  .schedule-container {

    .datepicker-container {
      height: 36px;

      ::v-deep(.input),
      .input,
      :deep(.input) {
        width: 100px;
        font-size: 13px;
      }

      .button {
        padding: 6px;
      }
    }

    .refresh-button {
      height: 36px;
      padding: 0 12px;
      font-size: 13px;
    }
  }
}
</style>
